export default function extractIdFromEncodedString(str?: string) {
  return (
    atob(str || '')
      .match(/:(.+)/)?.[1]
      .trim() || ''
  )
}
